<template>
  <div class="recent-comment">
    <div class="d-flex align-items-top">
      <div class="pr-2"><user-icon :userid="commentData['user.user_name']"></user-icon></div>
      <div class="">
        <div
          class="username-text d-block d-sm-inline-block"
          v-html="parseUserName(commentData['user.user_name'])"
        />
        <div class="comment-timestamp d-block d-sm-inline-block">{{
          getCommentDisplayTime(commentData["sys_created_on"])
        }}</div>
        <div v-if="isAdmin" class="reply-admin-role-text d-block d-sm-inline-block">ADMIN
          <span v-if="commentData.comments && commentData.u_email_only && commentData.u_email_only === 'true'"> - RESPONDED VIA EMAIL</span>
        </div>
      </div>
    </div>
    <div v-if="commentData.comments && (!commentData.u_email_only || commentData.u_email_only === 'false')" class="comment-text">
      <froalaView v-model="commentData.comments"></froalaView>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import UserIcon from "@/components/UserIcon";
import * as CONSTANTS from "@/store/constants";
import { mapGetters } from "vuex";

export default {
  name: "knowledge-article-comment",
  props: {
    commentData: Object, 
    isAdmin: {
        type: Boolean,
        default: false
    }
  },
  components: {
      UserIcon
  },
  computed: {
    ...mapGetters(["userName"]),
  },
  methods: {
    parseUserName(userId) {
      if (userId) {
        var displayName = this.userName(userId);
        if (displayName && displayName != userId) {
          return `<a href="/profile/${userId}">${displayName}</a>`;
        }
      }
      if (this.commentData['fullName']) {
        var displayName = this.commentData['fullName'];
        return `${displayName}`;
      }
      return "Unknown User";
    },

    getCommentDisplayTime(createdAt) {
      return moment.utc(createdAt).local().format("YYYY-MM-DD h:mm A");
    },

    parseComments(comments) {
      return comments.replace(
        CONSTANTS.URL_MATCHER,
        (match) => `<a href="${match}">${match}</a>`
      );
    },
  },
};
</script>

<style scoped>
.username-text {
  color: var(--secondary-color) !important;
  font-size: 16px;
  font-weight: bold;
  padding-right: 2px;
}
.username-text >>> a {
  color: var(--secondary-color) !important;
}
.username-text:hover >>> a {
  color: var(--secondary-color-hover) !important;
}


.comment-timestamp {
  font-size: 11pt;
  color: #000000;
  padding-right: 6px;
}
.comment-text {
  display: inline-block;
  flex-basis: auto;
  flex-shrink: 1;
  overflow: hidden;
  text-overflow: ellipsis;
  padding-left: 40px;
  font-size: 16px;
  color: #000000;
  word-break: break-word;
}
.comment-text >>> a {
  color: var(--secondary-color) !important;
}
.comment-text:hover >>> a {
  color: var(--secondary-color-hover) !important;
}

.reply-admin-role-text {
  font-size: 12px;
  font-weight: bold;
  color: #64788d;
  padding-top: 2px;
}
</style>



// WEBPACK FOOTER //
// src/components/knowledge-article/KnowledgeArticleComment.vue